module.exports = __webpack_public_path__ + "static/media/vedVastu.878f43fb.png";